(() => {
  const initializedBundles = new WeakSet();
  const retryTimers = new WeakMap();
  const warnedMissingVariantId = new WeakSet();

  const getProductInfo = () => document.querySelector('product-info');
  const getProductForm = () => getProductInfo()?.querySelector('form[data-type="add-to-cart-form"]') || null;

  const getAvailableQuantities = (bundle) =>
    Array.from(bundle.querySelectorAll('[data-thorbes-bundle-option]'))
      .map((option) => Number.parseInt(option.dataset.quantity, 10))
      .filter((quantity) => Number.isInteger(quantity) && quantity > 0);

  const normalizeQuantity = (bundle, value) => {
    const quantity = Number.parseInt(value, 10);
    const availableQuantities = getAvailableQuantities(bundle);

    if (availableQuantities.includes(quantity)) return quantity;

    const defaultQuantity = Number.parseInt(bundle.dataset.defaultQuantity, 10);
    if (availableQuantities.includes(defaultQuantity)) return defaultQuantity;

    return availableQuantities[0] || 1;
  };

  const ensureQuantityInput = (form) => {
    let input = form.querySelector('input[name="quantity"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      form.appendChild(input);
    }

    return input;
  };

  const getSelectedQuantity = (bundle) => {
    const checkedInput = bundle.querySelector('[data-thorbes-bundle-input]:checked');
    return normalizeQuantity(bundle, checkedInput?.value || bundle.dataset.defaultQuantity);
  };

  const getSelectedOption = (bundle) => {
    const checkedInput = bundle.querySelector('[data-thorbes-bundle-input]:checked');
    if (checkedInput) return checkedInput.closest('[data-thorbes-bundle-option]');

    const selectedQuantity = normalizeQuantity(bundle, bundle.dataset.defaultQuantity);
    return bundle.querySelector(`[data-thorbes-bundle-option][data-quantity="${selectedQuantity}"]`);
  };

  const getFormVariantId = () => {
    const form = getProductForm();
    return form?.querySelector('[name="id"]')?.value?.trim() || '';
  };

  const getQuantityByVariantId = (bundle, variantId) => {
    if (!variantId) return null;

    const option = Array.from(bundle.querySelectorAll('[data-thorbes-bundle-option]')).find(
      (bundleOption) => bundleOption.dataset.variantId?.trim() === variantId
    );

    return option?.dataset.quantity || null;
  };

  const getInitialQuantity = (bundle) => {
    if (bundle.dataset.bundleMode !== 'vitrine') return bundle.dataset.defaultQuantity || 2;

    const currentVariantQuantity = getQuantityByVariantId(bundle, getFormVariantId());
    return currentVariantQuantity || bundle.dataset.defaultQuantity || 1;
  };

  const setSelectedQuantity = (bundle, quantity) => {
    const selectedQuantity = normalizeQuantity(bundle, quantity);
    const selectedInput = bundle.querySelector(`[data-thorbes-bundle-input][value="${selectedQuantity}"]`);

    bundle.querySelectorAll('[data-thorbes-bundle-input]').forEach((input) => {
      input.checked = input === selectedInput;
    });

    bundle.querySelectorAll('[data-thorbes-bundle-option]').forEach((option) => {
      option.classList.toggle('is-selected', normalizeQuantity(bundle, option.dataset.quantity) === selectedQuantity);
    });

    syncOfferToForm(bundle, selectedQuantity);
  };

  const syncOfferToForm = (bundle, quantity = getSelectedQuantity(bundle), attempts = 0) => {
    const form = getProductForm();

    if (!form) {
      if (attempts < 10) {
        window.clearTimeout(retryTimers.get(bundle));
        retryTimers.set(bundle, window.setTimeout(() => syncOfferToForm(bundle, quantity, attempts + 1), 120));
      }
      return;
    }

    const isVitrineMode = bundle.dataset.bundleMode === 'vitrine';
    const selectedOption = getSelectedOption(bundle);
    const variantId = selectedOption?.dataset.variantId?.trim();
    const variantInput = form.querySelector('[name="id"]');
    const quantityInput = isVitrineMode ? null : ensureQuantityInput(form);

    if (variantInput && variantId) {
      variantInput.value = variantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (selectedOption && !variantId && !warnedMissingVariantId.has(selectedOption)) {
      warnedMissingVariantId.add(selectedOption);
      console.warn('Thorbes bundle: variant_id nao configurado para esta oferta. Mantendo a variante atual do formulario.');
    }

    if (quantityInput) {
      quantityInput.value = '1';
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const moveBundleNearBuyButton = (bundle) => {
    const productInfo = getProductInfo();
    const productForm = productInfo?.querySelector('product-form');

    if (!productInfo || !productForm || productForm.contains(bundle)) return;

    productForm.insertAdjacentElement('beforebegin', bundle);
    productInfo.classList.add('thorbes-bundle-active');
  };

  const bindFormSubmit = (bundle) => {
    const form = getProductForm();

    if (!form) {
      window.setTimeout(() => bindFormSubmit(bundle), 120);
      return;
    }

    if (form.dataset.thorbesBundleBound === 'true') return;
    form.dataset.thorbesBundleBound = 'true';

    form.addEventListener('submit', () => {
      syncOfferToForm(bundle, getSelectedQuantity(bundle));
    });
  };

  const initBundle = (bundle) => {
    if (initializedBundles.has(bundle)) return;
    initializedBundles.add(bundle);

    moveBundleNearBuyButton(bundle);
    setSelectedQuantity(bundle, getInitialQuantity(bundle));
    bindFormSubmit(bundle);

    bundle.addEventListener('click', (event) => {
      const option = event.target.closest('[data-thorbes-bundle-option]');
      if (!option || !bundle.contains(option)) return;

      event.preventDefault();
      setSelectedQuantity(bundle, option.dataset.quantity);
    });

    bundle.addEventListener('change', (event) => {
      if (!event.target.matches('[data-thorbes-bundle-input]')) return;
      setSelectedQuantity(bundle, event.target.value);
    });
  };

  const initAllBundles = () => {
    document.querySelectorAll('[data-thorbes-bundle]').forEach(initBundle);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBundles, { once: true });
  } else {
    initAllBundles();
  }
})();
